import FunnelIcon from '@heroicons/react/24/outline/FunnelIcon';
import RecordIconAllow from '@heroicons/react/24/outline/VideoCameraIcon';
import RecordIconNotAllow from '@heroicons/react/24/outline/VideoCameraSlashIcon';
import XMarkIcon from '@heroicons/react/24/outline/XMarkIcon';
import moment from 'moment';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { supabase } from '../../../data/supabase';
import TitleCard from '../../../shared/components/Cards/TitleCard';
import SearchBar from '../../../shared/components/Input/SearchBar';
import { useAuth } from '../../../shared/context/useAuth';
import useAppoitments from '../../../shared/hooks/useAppointment/patient';
import { openModal } from '../../../store/reducers/modal';
import { MODAL_BODY_TYPES } from '../../../utils/globalConstantUtil';

function TopSideButtons({ removeFilter, applyFilter, applySearch }) {
  const [filterParam, setFilterParam] = useState('');
  const [searchText, setSearchText] = useState('');
  const locationFilters = [
    'pending',
    'em andamento',
    'canceled pac',
    'canceled pro',
    'confirmed',
  ];

  const showFiltersAndApply = (params) => {
    applyFilter(params);
    setFilterParam(params);
  };

  const removeAppliedFilter = () => {
    removeFilter();
    setFilterParam('');
    setSearchText('');
  };

  useEffect(() => {
    if (searchText === '') {
      removeAppliedFilter();
    } else {
      applySearch(searchText);
    }
  }, [searchText]);

  return (
    <div className="inline-block float-right">
      <SearchBar
        searchText={searchText}
        styleClass="mr-4"
        setSearchText={setSearchText}
      />
      {filterParam !== '' && (
        <button
          onClick={() => removeAppliedFilter()}
          className="btn btn-xs mr-2 btn-active btn-ghost normal-case"
        >
          {filterParam}
          <XMarkIcon className="w-4 ml-2" />
        </button>
      )}
      <div className="dropdown dropdown-bottom dropdown-end">
        <label tabIndex={0} className="btn btn-sm btn-outline">
          <FunnelIcon className="w-5 mr-2" />
          Filtro
        </label>
        <ul
          tabIndex={0}
          className="dropdown-content menu p-2 text-sm shadow bg-base-100 rounded-box w-52"
        >
          {locationFilters.map((l, k) => (
            <li key={k}>
              <a onClick={() => showFiltersAndApply(l)}>{l}</a>
            </li>
          ))}
          <div className="divider mt-0 mb-0" />
          <li>
            <a onClick={() => removeAppliedFilter()}>Remover Filtro</a>
          </li>
        </ul>
      </div>
    </div>
  );
}

function AppointmentsPatient() {
  const { patient, currentUser, session } = useAuth();
  const dispatch = useDispatch();
  
  const { data: appointmentsPatient, refetch } = useAppoitments(patient && patient[0]?.id);
  const [trans, setTrans] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  // Atualizar o estado trans quando appointmentsPatient mudar
  useEffect(() => {
    if (appointmentsPatient && Array.isArray(appointmentsPatient)) {
      const sortData = [...appointmentsPatient].sort((a, b) => {
        return b?.start_history?.localeCompare(a?.start_history);
      });
      setTrans(sortData);
    }
  }, [appointmentsPatient]);

  const removeFilter = () => {
    if (appointmentsPatient && Array.isArray(appointmentsPatient)) {
      const sortData = [...appointmentsPatient].sort((a, b) => {
        return b?.start_history?.localeCompare(a?.start_history);
      });

      console.log('SORT', sortData);
      
      setTrans(sortData);
    }
  };

  const applyFilter = (params) => {
    if (!trans || !Array.isArray(trans)) return;
    
    const filteredTransactions = trans.filter((t) => {
      return t.status === params;
    });
    setTrans(filteredTransactions);
  };

  // Search according to name
  const applySearch = (value) => {
    if (!trans || !Array.isArray(trans)) return;
    
    const filteredTransactions = trans.filter(
      (t) =>
        t.specialist?.name?.toLowerCase().includes(value.toLowerCase()) ||
        t.specialist?.name?.toLowerCase().includes(value.toLowerCase()),
    );
    setTrans(filteredTransactions);
  };

  // Função para abrir o modal de cancelamento
  const handleCancelMeet = async (appointment) => {
    if (!appointment) return;
    
    // Garantir que temos todos os dados necessários
    if (!appointment.patient_id && patient && patient[0]?.id) {
      appointment.patient_id = patient[0].id;
    }
    
    setSelectedAppointment(appointment);
    setShowCancelModal(true);
  };

  // Função para processar o cancelamento após confirmação
  const processCancelation = async () => {
    if (!selectedAppointment || isProcessing) return;
    
    try {
      setIsProcessing(true);
      
      const appointmentStart = moment(selectedAppointment.start_history);
      const now = moment();
      const hoursUntilAppointment = appointmentStart.diff(now, 'hours');
      const isMoreThan24h = hoursUntilAppointment >= 24;
      
      console.log(`Horas até a consulta: ${hoursUntilAppointment}`);
      console.log('Detalhes do agendamento:', selectedAppointment);
      
      // Garantir que temos o patient_id
      if (!selectedAppointment.patient_id && patient && patient[0]?.id) {
        selectedAppointment.patient_id = patient[0].id;
      }
      
      // Determinar o tipo de crédito usado
      let isPackageAppointment = false;
      
      // Verificar se é um agendamento de pacote de várias maneiras
      if (selectedAppointment.is_package === true || 
          selectedAppointment.package_id || 
          selectedAppointment.package_session_id) {
        isPackageAppointment = true;
      } else {
        try {
          // Verificar na tabela de transações se está associado a um pacote
          const { data: transactionData } = await supabase
            .from('credit_transactions')
            .select('source_type')
            .eq('appointment_id', selectedAppointment.id)
            .eq('transaction_type', 'appointment');
            
          if (transactionData && transactionData.length > 0) {
            isPackageAppointment = transactionData[0].source_type === 'package';
          }
        } catch (error) {
          console.error('Erro ao verificar tipo de transação:', error);
          // Continuar mesmo se não conseguir verificar
        }
      }
      
      console.log('É agendamento de pacote?', isPackageAppointment);
      
      // 1. Primeiro, atualizar o status do agendamento para cancelado
      const { error: updateAppointmentError } = await supabase
        .from('appointment')
        .update({ 
          status: 'canceled pac',
          notes: `Cancelado pelo paciente em ${new Date().toISOString()}. ${isMoreThan24h ? 'Crédito devolvido' : 'Crédito perdido'}`
        })
        .eq('id', selectedAppointment.id);
        
      if (updateAppointmentError) {
        throw new Error(`Erro ao atualizar status do agendamento: ${updateAppointmentError.message}`);
      }
      
      // 2. Processar o cancelamento baseado no tipo e tempo
      if (isMoreThan24h) {
        // Cancelamento com mais de 24h - devolver crédito
        try {
          if (isPackageAppointment) {
            await handlePackageCancellation(selectedAppointment, true);
          } else {
            await handleCreditCancellation(selectedAppointment, true);
          }
          
          toast.success(
            <span>
              Agendamento Cancelado! <br /> 
              Seu crédito foi devolvido e está disponível para uso.
            </span>,
            { duration: 5000 }
          );
        } catch (creditError) {
          console.error('Erro ao processar devolução de crédito:', creditError);
          // Continuar mesmo se falhar a devolução de crédito
          toast.success(
            <span>
              Agendamento Cancelado! <br /> 
              <span className="text-yellow-600">Nota: Houve um problema ao processar a devolução do crédito. Entre em contato com o suporte.</span>
            </span>,
            { duration: 7000 }
          );
        }
      } else {
        // Cancelamento com menos de 24h - não devolver crédito
        toast.success(
          <span>
            Agendamento Cancelado! <br /> 
            Seu crédito foi perdido devido ao cancelamento com menos de 24 horas de antecedência.
          </span>,
          { duration: 5000 }
        );
      }
      
      // Atualizar a lista de agendamentos
      if (refetch) {
        await refetch();
      } else {
        // Alternativa se refetch não estiver disponível
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
      
    } catch (error) {
      console.error('Erro ao cancelar consulta:', error);
      toast.error(`Erro ao processar o cancelamento: ${error.message || 'Erro desconhecido'}`);
    } finally {
      setIsProcessing(false);
      setShowCancelModal(false);
    }
  };
  
  // Função para lidar com cancelamento de pacote
  const handlePackageCancellation = async (appointment, returnCredit) => {
    try {
      if (!appointment || !appointment.id) {
        throw new Error('Dados do agendamento inválidos');
      }
      
      if (!appointment.patient_id && patient && patient[0]?.id) {
        appointment.patient_id = patient[0].id;
      }
      
      // Se não for para devolver crédito, apenas registramos o cancelamento
      if (!returnCredit) {
        console.log('Cancelamento sem devolução de crédito');
        return;
      }
      
      // Buscar a carteira do paciente com base na categoria do agendamento
      const { data: walletData, error: walletError } = await supabase
        .from('wallet')
        .select('*')
        .eq('patient_id', appointment.patient_id)
        .eq('type', appointment.category || 'individual')
        .single();
      
      if (walletError && walletError.code !== 'PGRST116') {
        throw new Error(`Erro ao buscar carteira: ${walletError.message}`);
      }
      
      if (!walletData) {
        throw new Error('Carteira não encontrada para este paciente e tipo de crédito');
      }
      
      console.log('Carteira encontrada:', walletData);
      
      // Atualizar a carteira incrementando o crédito
      const { error: updateWalletError } = await supabase
        .from('wallet')
        .update({
          balance: walletData.balance + 1,
          updated_at: new Date().toISOString()
        })
        .eq('id', walletData.id);
      
      if (updateWalletError) {
        throw new Error(`Erro ao atualizar carteira: ${updateWalletError.message}`);
      }
      
      // Registrar a transação de devolução
      const { error: transactionError } = await supabase
        .from('credit_transactions')
        .insert({
          wallet_id: walletData.id,
          amount: 1,
          transaction_type: 'cancellation',
          source_type: 'package',
          source_id: appointment.package_id || null,
          appointment_id: appointment.id,
          created_at: new Date().toISOString(),
          notes: `Devolução de crédito por cancelamento de consulta (mais de 24h de antecedência)`
        });
      
      if (transactionError) {
        throw new Error(`Erro ao registrar transação: ${transactionError.message}`);
      }
      
      // Se temos um package_id, atualizar o pacote
      if (appointment.package_id) {
        try {
          // Buscar o pacote
          const { data: packageData, error: packageError } = await supabase
            .from('packages')
            .select('*')
            .eq('id', appointment.package_id)
            .single();
          
          if (packageError && packageError.code !== 'PGRST116') {
            throw new Error(`Erro ao buscar pacote: ${packageError.message}`);
          }
          
          if (packageData) {
            // Atualizar o pacote incrementando as sessões restantes
            const { error: updatePackageError } = await supabase
              .from('packages')
              .update({
                remaining_sessions: packageData.remaining_sessions + 1,
                updated_at: new Date().toISOString()
              })
              .eq('id', packageData.id);
            
            if (updatePackageError) {
              throw new Error(`Erro ao atualizar pacote: ${updatePackageError.message}`);
            }
          }
        } catch (packageError) {
          console.error('Erro ao atualizar pacote:', packageError);
          // Continuar mesmo se falhar a atualização do pacote
        }
      }
      
      // Se temos um package_session_id, atualizar a sessão
      if (appointment.package_session_id) {
        try {
          // Calcular nova data de expiração (7 dias a partir de hoje)
          const newExpiryDate = moment().add(7, 'days').toISOString();
          
          // Atualizar a sessão
          const { error: updateSessionError } = await supabase
            .from('sessions')
            .update({
              status: 'available',
              session_expiry: newExpiryDate,
              updated_at: new Date().toISOString()
            })
            .eq('id', appointment.package_session_id);
          
          if (updateSessionError) {
            throw new Error(`Erro ao atualizar sessão: ${updateSessionError.message}`);
          }
        } catch (sessionError) {
          console.error('Erro ao atualizar sessão:', sessionError);
          // Continuar mesmo se falhar a atualização da sessão
        }
      }
      
      console.log('Cancelamento de pacote processado com sucesso');
      
    } catch (error) {
      console.error('Erro ao processar cancelamento de pacote:', error);
      throw error;
    }
  };
  
  // Função para lidar com cancelamento de crédito individual
  const handleCreditCancellation = async (appointment, returnCredit) => {
    try {
      if (!appointment || !appointment.id) {
        throw new Error('Dados do agendamento inválidos');
      }
      
      if (!appointment.patient_id && patient && patient[0]?.id) {
        appointment.patient_id = patient[0].id;
      }
      
      // Se não for para devolver crédito, apenas registramos o cancelamento
      if (!returnCredit) {
        console.log('Cancelamento sem devolução de crédito');
        return;
      }
      
      // Buscar a carteira do paciente com base na categoria do agendamento
      const { data: walletData, error: walletError } = await supabase
        .from('wallet')
        .select('*')
        .eq('patient_id', appointment.patient_id)
        .eq('type', appointment.category || 'individual')
        .single();
      
      if (walletError && walletError.code !== 'PGRST116') {
        throw new Error(`Erro ao buscar carteira: ${walletError.message}`);
      }
      
      if (!walletData) {
        throw new Error('Carteira não encontrada para este paciente e tipo de crédito');
      }
      
      console.log('Carteira encontrada:', walletData);
      
      // Atualizar a carteira incrementando o crédito
      const { error: updateWalletError } = await supabase
        .from('wallet')
        .update({
          balance: walletData.balance + 1,
          updated_at: new Date().toISOString()
        })
        .eq('id', walletData.id);
      
      if (updateWalletError) {
        throw new Error(`Erro ao atualizar carteira: ${updateWalletError.message}`);
      }
      
      // Registrar a transação de devolução
      const { error: transactionError } = await supabase
        .from('credit_transactions')
        .insert({
          wallet_id: walletData.id,
          amount: 1,
          transaction_type: 'cancellation',
          source_type: 'individual_credit',
          appointment_id: appointment.id,
          created_at: new Date().toISOString(),
          notes: `Devolução de crédito por cancelamento de consulta (mais de 24h de antecedência)`
        });
      
      if (transactionError) {
        throw new Error(`Erro ao registrar transação: ${transactionError.message}`);
      }
      
      console.log('Cancelamento de crédito individual processado com sucesso');
      
    } catch (error) {
      console.error('Erro ao processar cancelamento de crédito individual:', error);
      throw error;
    }
  };

  const [reviews, setReviews] = useState({});

  function handleReview(data) {
    dispatch(
      openModal({
        title: 'Faça sua avaliação',
        bodyType: MODAL_BODY_TYPES.REVIEW,
        extraObject: {
          specialist: data.specialist,
          patient: currentUser?.id,
          setReviews
        },
      }),
    );
  }

  // Função para carregar reviews
  const loadReviews = async () => {
    if (!currentUser?.id) return;
    
    try {
      const { data, error } = await supabase
        .from('reviews')
        .select('id_spec, id_pac')
        .eq('id_pac', currentUser.id);

      if (error) {
        console.error(error);
        toast.error('Erro ao carregar avaliações');
        return;
      }

      // Formate os dados para facilitar o acesso
      const reviewsMap = {};
      if (data && Array.isArray(data)) {
        data.forEach((review) => {
          if (review.id_spec) {
            reviewsMap[review.id_spec] = true;
          }
        });
      }
      setReviews(reviewsMap);
    } catch (error) {
      console.error('Erro ao carregar avaliações:', error);
    }
  };

  // Carregue as avaliações no `useEffect`
  useEffect(() => {
    if (patient?.length > 0) {
      loadReviews();
    }
  }, [patient, currentUser?.id]);

  const getDummyStatus = (index, item) => {
    if (!index) return <div className="badge badge-ghost">Desconhecido</div>;
    
    if (index === 'pending')
      return <div className="badge badge-warning">Pendente</div>;
    if (index === 'running')
      return <div className="badge badge-primary">Em andamento</div>;
    if (index === 'canceled pac')
      return (
        <div className="badge badge-error text-white">Cancelado | Paciente</div>
      );
    if (index === 'canceled pro')
      return (
        <div className="badge badge-error text-white">
          Cancelado | Especialista
        </div>
      );
    if (index === 'confirmed')
      return <div className="badge badge-accent">Confirmado</div>;
  
    if (index === 'realizado') {
      const hasReviewed = item?.specialist?.id && reviews[item.specialist.id]; // Verifica se já existe review
      if (hasReviewed) {
        return (
          <div className="badge badge-success text-white">
            Avaliação feita
          </div>
        );
      }
      return (
        <a
          onClick={() => handleReview(item)}
          className="badge badge-accent cursor-pointer"
        >
          Faça avaliação
        </a>
      );
    }
  
    return <div className="badge badge-ghost">Open</div>;
  };
  
  const location = useLocation();
  
  function verifyStatus(item) {
    if (!item) return null;
    
    if (moment(new Date().toJSON()).isAfter(
      moment(item?.end)
    ) && (item?.status !== 'canceled pac' && item?.status !== 'canceled pro')) {
      return "realizado";
    }
    return item.status;
  }

  // Verifica se a consulta pode ser cancelada
  const canCancel = (appointment) => {
    if (!appointment) return false;
    
    // Verifica se a consulta já foi cancelada
    if (appointment.status === 'canceled pac' || appointment.status === 'canceled pro') {
      return false;
    }
    
    // Verifica se a consulta já aconteceu
    if (moment(new Date().toJSON()).isAfter(moment(appointment.start_history))) {
      return false;
    }
    
    return true;
  };


  console.log('trans', trans);
  
  // Função para determinar a mensagem de cancelamento
  const getCancelMessage = (appointment) => {
    if (!appointment || !appointment.start_history) {
      return "Cancelar";
    }
    
    const appointmentStart = moment(appointment.start_history);
    const now = moment();
    const hoursUntilAppointment = appointmentStart.diff(now, 'hours');
    
    if (hoursUntilAppointment >= 24) {
      return "Cancelar (crédito será devolvido)";
    } else {
      return "Cancelar (crédito será perdido)";
    }
  };

  return (
    <>
      {location.pathname !== '/' && (
        <div className="w-full col-span-12">
          <div className="relative p-6 rounded-2xl bg-[#3bbdcf] text-primary-content row-start-1 row-end-2 col-span-3 md:col-span-3 lg:col-span-4">
            <h2 className="font-bold text-2xl mb-6">Minhas Consultas</h2>
            <h2 className="font-light text-xl">Veja suas consultas</h2>
            <p>Acesse links e acompanhe em tempo real o status das consultas</p>
            <img
              src="/common/pro2.png"
              alt="doctor"
              className="absolute bottom-0 right-7 mobile:hidden"
              width={190}
            />
          </div>
        </div>
      )}

      <TitleCard
        topMargin="mt-2"
        TopSideButtons={
          <TopSideButtons
            applySearch={applySearch}
            applyFilter={applyFilter}
            removeFilter={removeFilter}
          />
        }
      >
        {/* Team Member list in table format loaded constant */}
        <div className="overflow-x-auto w-full">
          <table className="table w-full overflow-hidden h-full">
            {trans?.length > 0 && (
              <thead>
                <tr>
                  <th>Especialista</th>
                  <th>Link agenda</th>
                  <th>Tipo de Sessão</th>
                  <th>Data / Hora</th>
                  <th className="w-[10px]">Status</th>
                  <th className="w-[10px]"> </th>
                </tr>
              </thead>
            )}
            <tbody>
              
              {trans?.length > 0 ? (
                trans.map((l, k) => (
                  <tr key={k}>
                    <td>
                      <div className="flex items-center space-x-3">
                        <div>
                          <div className="font-bold">{l?.specialist?.name || 'Nome não disponível'}</div>
                        </div>
                      </div>
                    </td>
                    <td>
  {l?.start_history && !moment(new Date().toJSON()).isAfter(
    moment(l.start_history).add(50, 'minutes'),
  ) && l?.status !== 'canceled pac' && l?.status !== 'canceled pro' ? (
    <a 
      rel="noreferrer" 
      href={l?.meetLink || '#'} 
      
      className="flex items-center"
    >
      {l?.meetIconUri ? (
        <img 
          src={l?.meetIconUri} 
          alt="Google Meet" 
          className="w-5 h-5 mr-1"
        />
      ) : (
        <RecordIconAllow height={22} width={22} className="mr-1" />
      )}
      
    </a>
  ) : (
    <div
      className="tooltip hover:tooltip-open tooltip-bottom flex items-center"
      data-tip="Link expirado ou cancelado"
    >
      <RecordIconNotAllow height={22} width={22} className="mr-1" />
      <span className="text-xs text-gray-400">Indisponível</span>
    </div>
  )}
</td>
                    <td>{l?.category || 'Sem categoria'}</td>
                    <td>
                      {l?.start_history ? (
                        moment(l.start_history).format('D MMM HH:mm')
                      ) : (
                        <p className="text-error">Sem data</p>
                      )}
                    </td>
                    <td>{getDummyStatus(verifyStatus(l), l)}</td>
                    <td className="w-[20px]">
                      {canCancel(l) && (
                        <div className="dropdown dropdown-left">
                          <div tabIndex={0} role="button" className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                              />
                            </svg>
                          </div>
                          <ul
                            tabIndex={0}
                            className="dropdown-content z-[1] menu shadow bg-base-100 rounded-box w-64"
                          >
                            <li>
                              <a
                                onClick={() => handleCancelMeet(l)}
                                className={`font-medium ${
                                  l?.start_history && moment(l.start_history).diff(moment(), 'hours') < 24 
                                    ? 'text-red-500' 
                                    : 'text-yellow-600'
                                }`}
                              >
                                {getCancelMessage(l)}
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">
                    <span className="flex pt-6 text-[#666] font-bold">
                      Nada encontrado.
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </TitleCard>

      {/* Modal de confirmação de cancelamento */}
      {showCancelModal && selectedAppointment && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h2 className="text-xl font-bold mb-4">Confirmar Cancelamento</h2>
            
            <p className="mb-4">
              Você está prestes a cancelar sua consulta agendada para:
              <span className="block font-semibold mt-2">
                {selectedAppointment.start_history ? 
                  moment(selectedAppointment.start_history).format('DD/MM/YYYY [às] HH:mm') :
                  'Data não disponível'
                }
              </span>
              com o especialista <span className="font-semibold">
                {selectedAppointment.specialist?.name || 'Nome não disponível'}
              </span>
            </p>
            
                        {selectedAppointment.start_history && moment(selectedAppointment.start_history).diff(moment(), 'hours') >= 24 ? (
              <div className="p-3 rounded-md mb-4 bg-yellow-100 text-yellow-700">
                <p className="text-sm">
                  <span className="font-bold">Política de cancelamento:</span> Como você está cancelando com mais de 24 horas de antecedência, seu crédito será devolvido.
                  {selectedAppointment.is_package || selectedAppointment.package_id ? 
                    ' O crédito será válido para uso futuro.' : 
                    ' O crédito será devolvido para uso futuro sem prazo de validade.'}
                </p>
              </div>
            ) : (
              <div className="p-3 rounded-md mb-4 bg-red-100 text-red-700">
                <p className="text-sm">
                  <span className="font-bold">Atenção:</span> Como você está cancelando com menos de 24 horas de antecedência, seu crédito será perdido conforme nossa política de cancelamento.
                </p>
              </div>
            )}
            
            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={() => setShowCancelModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
                disabled={isProcessing}
              >
                Voltar
              </button>
              <button
                onClick={processCancelation}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 flex items-center"
                disabled={isProcessing}
              >
                {isProcessing ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processando...
                  </>
                ) : (
                  'Confirmar Cancelamento'
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AppointmentsPatient;